import React from "react";
import { Link } from "react-router-dom";
import { Divider } from "antd";
import Logo from "components/UI/Logo/Logo";
import FarathLogo from "../../../assets/images/Farath_Holdings-rbg.png";
import AuthBanner from "../../../assets/images/auth-banner.png";

import { LOGIN_PAGE } from "settings/constant";
import SignUpForm from "./SignUpForm";
// Import any other necessary components or types
import Wrapper, {
  Title,
  TitleInfo,
  Text,
  FormWrapper,
  BannerWrapper,
} from "../Auth.style";

const SignUp: React.FC = () => {
  return (
    <Wrapper>
      <FormWrapper>
        <Logo withLink linkTo="/" src={FarathLogo} title="Farath Holdings." />
        <Title>Welcome To Farath Holdings.</Title>
        <TitleInfo>Please create your account</TitleInfo>
        <SignUpForm />
        {/* <Divider>Or Register Up With </Divider> */}
        {/* <SocialLogin /> */}
        <Text style={{ marginTop: "20px" }}>
          Already have an account?&nbsp;
          <Link to={LOGIN_PAGE}>Sign In</Link>
        </Text>
      </FormWrapper>
      <BannerWrapper>
        <img src={AuthBanner} alt="Auth page banner" />
      </BannerWrapper>
    </Wrapper>
  );
};

export default SignUp;
